import React from "react";
import { NavLink } from "react-router-dom";

import SidebarMenuItems from "./items";
import ItemLabel from "./label";

class item extends React.Component {
    get page() {
        return this.props.item;
    }

    render() {

        if (this.page.contains && !this.page.contains?.hide) {
            return (
                <li>
                    <NavLink to={this.page.to} exact={this.page.exact} data-bs-target={this.page.to}>
                        <ItemLabel icon={this.page.icon} caption={this.page.title} />
                    </NavLink>
                    <ul>
                        <SidebarMenuItems items={this.page.contains.items} onPermitted={this.props.onPermitted} />
                    </ul>
                </li>
            );
        }
        if (this.page.target) {
            return (
                <li key={this.page.id}>
                    <a href={this.page.to} target={this.page.target} rel="noopener noreferrer">
                        <ItemLabel icon={this.page.icon} caption={this.page.title} />
                    </a>
                </li>
            );
        }
        return (
            <li>
                <NavLink to={this.page.to} exact={this.page.exact} activeClassName="">
                    <ItemLabel icon={this.page.icon} caption={this.page.title} />
                </NavLink>
            </li>
        );
    }
};

export default item;
